import React from 'react';

function CardImagenes({ imagenurl, title, children }) {
  return (
    <div className="relative w-64 h-60 rounded-lg overflow-hidden shadow-lg group">
      {/* Imagen con efecto de escala al hacer hover */}
      <img 
        src={imagenurl}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
      />

      {/* Capa superpuesta con transición de opacidad */}
      <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-blanco p-4 transition-opacity duration-500 opacity-0 group-hover:opacity-100">
        <h2 className="text-lg font-bold uppercase text-center">{title}</h2>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
}

export default CardImagenes;
